import * as React from 'react';
import locales from '../locales';
import {ColumnFilterItem} from 'antd/lib/table';

export const enum IncomingInvoiceState {
  OPEN = 'OPEN',
  TO_BE_TRANSFERRED = 'TO_BE_TRANSFERRED',
  TRANSFERRED = 'TRANSFERRED'
}

const stateColors = {
  [IncomingInvoiceState.OPEN]: 'gray',
  [IncomingInvoiceState.TO_BE_TRANSFERRED]: 'yellow',
  [IncomingInvoiceState.TRANSFERRED]: 'green'
};

const stateLabels = {
  [IncomingInvoiceState.OPEN]: locales.state_open,
  [IncomingInvoiceState.TO_BE_TRANSFERRED]: locales.state_to_be_transferred,
  [IncomingInvoiceState.TRANSFERRED]: locales.state_transferred
};

export const mapStateLabel = (state: string) => {
  return stateLabels[state];
};

export const renderIncomingInvoiceStateDot = (state?: string) => {
  const label = state ? stateLabels[state] : locales.state_open;
  const colorCls = state ? stateColors[state] : 'green';
  return <span
    title={label}
    className={'state-dot ' + colorCls}
  />;
};

export const renderIncomingInvoiceStateElement = (state?: string) => {
  const label = state ? stateLabels[state] : locales.state_open;
  const colorCls = state ? stateColors[state] : 'green';
  return (
    <div style={{whiteSpace: 'nowrap'}}>
      <span className={'state-dot ' + colorCls} style={{marginRight: 8}}/>
      <span>{label}</span>
    </div>
  )
};

export function getIncomingInvoiceStateFilters(): ColumnFilterItem[] {
  return [IncomingInvoiceState.OPEN, IncomingInvoiceState.TO_BE_TRANSFERRED, IncomingInvoiceState.TRANSFERRED]
    .map(state => ({text: stateLabels[state], value: state}));
}


// WEBPACK FOOTER //
// ./src/incoming-invoices/incoming-invoice-state.tsx